import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { makeStyles } from "@mui/styles";
import styled from "styled-components";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import CircularLoader from "../CircularLoader/CircularLoader";
import environmentVariables from "../../config/environmentVariables";
import { userInfoContext } from "../../context/userInfoContext";

const SuccessIcon = `${environmentVariables?.cdnUrl}successicon.png`
import { approve, checkAllowance, getRate, swapTokens } from "../../config/provider";
import { SwapingContract } from "../../config/data";
import { ethers } from "ethers";
import ConfirmPopup from "../ConfirmPopup";
import { formatNumber } from "../../config/common";
import { userBalanceContext } from "../../context/userBalanceContext";
const InputWrapper = styled.div`
  width: 100%;
  font-size: 18px;
  /* background: rgba(40, 43, 47, 0.8)r-; */
  outline: none;
  border: none;
  font-weight: 400;
  text-align: left;
  color: #75787b;
  line-height: 16px;
  // padding: 2px 0px 0px 20px;
  border-radius: 10px;
  border: none;
`;
const Paywith = styled.div`
  font-size: 16px;
  font-weight: 500;
  padding: 30px 0 10px;
  color: #d1d1d1;
`;
const Fortwoinputslandscape = styled.div`
  display: block;
  @media (max-height: 480px) {
    display: flex;
    gap: 20px;
  }
`;
const Inputwidthlandscape = styled.div`

  @media (max-height: 480px) {
    width: 100%;
  }
`;

const ErrorMessage=styled.div`

  font-size: 14px;
  position: absolute;
  top: 280px;
  @media (max-width: 600px) {
    font-size: 12px;
    top: 290px;
  }
`
const PaywithBox = styled.div`
  font-size: 16px;
  position: relative;
`;

const ButtonWrapper = styled.div`
  padding: 5px 0 5px 0;
  margin-top: 10px;
`;
const Button = styled.button`
  background: rgb(31 92 106);
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.06);
  border: none;
  font-weight: 700;
  text-align: center;
  color: #fff;
  margin: 0 auto;
  display: block;
  border-radius: 10px;
  padding: 15px 50px;
  font-size: 18px;
  // cursor: pointer;
  cursor: pointer;
  width: 100%;
`;
const useStyles = makeStyles((theme) => ({
  customButton: {
    padding: "50px",
    backgroundColor: "#2a2a2a",
    border: "1px solid #484848",
    borderRadius: "10px",
    color: "#fff",
    minWidth: "360px",
    width: "580px",
    "@media (max-width: 768px)": {
      minWidth: "360px",
    },
    "@media (max-width: 600px)": {
      maxWidth: "220px",
      minWidth: "350px",
      padding: "40px 30px",
      backgroundColortransparent: true,
    },
    "@media (max-width: 400px)": {
      maxWidth: "220px",
      minWidth: "320px",
      padding: "40px 30px",
      backgroundColortransparent: true,
    },
  },
}));
const TextWrapper = styled.div``;
const Text = styled.div`
  font-size: 18px;
  font-family: "SweraDemo";
  padding: 14px 0;
  flex: 1;
  min-width: 0;
  font-family: inherit;
  font-weight: 700;
  text-align: left;
  color: #b9b9b9;
  line-height: 20px;
`;
const Styledselect = styled.select`
  background: transparent;
  border: 0;
  color: #75787b;
  cursor: pointer;
  :focus {
    border: 0;
    outline: 0;
  }
  :focus-visible {
    border: 0;
    outline: 0;
  }
`;
const NftNameConfirmHead = styled.div`
  font-size: 24px;
  font-weight: 600;
`;
const CopyIcon = styled.div`
  position: relative;
  color: white;
  cursor: pointer;
  padding: 0 0 0 15px;
  @media (max-width: 425px) {
    padding: 0 0 0 5px;
  }
`;
const NftAmountConfirmSubHead2 = styled.div`
  font-size: 16px;
  display: flex;
  color: #bbb;
  @media (max-width: 600px) {
    font-size: 12px;
  }
`;
const NftNameConfirm = styled.div`
  width: 100%;
  margin: 20px 0;
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  padding-top: 20px;
  border-bottom: 1px solid #484848;
  border-top: 1px solid #484848;
  justify-content: space-between;
`;
const NftAmountConfirmHeadPur = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
`;

const NftAmountConfirmHead2 = styled.div`
  font-size: 16px;
  color: #bbb;
`;
const NftAmountConfirmSubHead3 = styled.div`
  font-size: 16px;
  color: #fff;
`;
const PayButtons = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const AddressWrapper = styled.div`
  margin: 1rem 0;
  position: relative;
  @media (max-height: 480px) {
    width: 100%;
  }

`;
const DialogStyledUpdate = styled(Dialog)``;
const AmountSubHead = styled.div`
  font-size: 16px;
  color: #6c6c6c;
  text-transform: capitalize;
`;
const ButtonConfirm = styled.button`
  background: linear-gradient(45deg, #0a5d6e, #00aacd);
  border-radius: 50px;
  outline: none;
  border: none;
  font-size: 24px;
  padding: 20px 80px;
  margin: 40px 0 10px;
  cursor: pointer;
  color: #e9e9e9;
  width: 100%;
  transition: 1s;
  @media (max-width: 768px) {
    margin: 5px 0;
  }
  /* &:hover {
    background: linear-gradient(45deg, #fff, #d3d3d3);
    color: #151a1c;
  } */
`;
const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 10px;
`;

const Image = styled.img`
  width: 12%;
`;

const Styledoption = styled.option`
  background: transparent;
  border: 0;
  color: #75787b;
  cursor: pointer;
`;

const ConversionPrice = styled.div`
  font-size: 14px;
  font-weight: 700;
  position: absolute;
  top: 395px;
  right: 36px;
  color: #b9b9b9;
  padding-top: 10px;
  text-align: right;
  @media (max-width:500px){
    top:405px;
  }
`;
const ToolTipSpan = styled.span`
  width: 80px;
  background-color: #f3eded;
  color: #080808;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 145%;
  margin-left: -60px;
  opacity: 1;
  font-weight: 700;
  transition: opacity 0.3s;
  ::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #f3eded transparent transparent transparent;
  }
`;
const ButtonCancel = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -15px;
  right: -20px;
  background-color: #b3b3b3;
  border-radius: 50px;
  outline: none;
  border: none;
  font-size: 20px;
  /* font-weight: 600; */
  padding: 20px;
  margin: 0;
  cursor: pointer;
  color: #000;
  width: 45px;
  height: 45px;
  transition: 1s;
  @media (max-width: 768px) {
    margin: 5px 0;
    top: -25px;
    right: -15px;
  }
  @media (max-width: 600px) {
    top: -25px;
    right: -15px;
  }

  /* &:hover {
    background: linear-gradient(45deg, #fff, #d3d3d3);
    color: #151a1c;
  } */
`;
const AmountHead = styled.div`
  font-size: 50px;
  font-weight: 600;
  color: #fff;
  padding-top: 5px;
  text-transform: capitalize;
`;
const NftNameConfirmSubHead = styled.div`
  font-size: 16px;
  color: #bbb;
  text-transform: capitalize;
`;
const NftNameConfirm4 = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 20px;
  padding-top: 50px;
`;
const SwapTokensWrapper = ({
  mldTokenName,
  maticTokenName,
  lordTokenName,
  getUserBalance,
  usdtTokenName,
  allContractDetails,
  isSwapsLoading,
  userSwapsToday,
  setUserSwapsToday,
  isUserWhitelisted,
}) => {
  const navigate = useNavigate();
  const classes = useStyles();
  const [tokenConversionRate, setTokenConversionRate] = useState(null);
  const [tokenAmount, setTokenAmount] = useState();
  const [showSuccessPopUp,setShowSucceessPopUp]=useState(false);
  const [currencyAmount, setCurrencyAmount] = useState();
   const [isCopied, setIsCopied] = useState(false);
  const [currency, setCurrency] = useState("USDT");
  const [transactionHash,setTransactionHash]=useState('')
  const [isSubmit, setIsSubmit] = useState(false);
  const [conversionRate, setConversionRate] = useState(0);
  const [conversionRates,setConversionRates] = useState(0);
  const [message,setMessage]=useState('')
  const [isBuyError,setIsBuyError]=useState(false)
  const [isBuyOpen,setIsBuyOpen]=useState(false);
  const {userAccInfo, setUserAccInfo}=useContext(userInfoContext)
  const {userBalance} = useContext(userBalanceContext)
  const [disableButton,setDisableButton]=useState(true)
  const [errorMsg,setErrorMsg]=useState(null)
  const [confirmPopUP, setConfirmPopUP] = useState(false);
  const [isWhitelistError, setIsWhitelistError] = useState(false);
  const [minLimit, setMinLimit] = useState(0);
  const [maxLimit, setMaxLimit] = useState(0);
  const [perDayLimit, setPerDayLimit] = useState(0);
  const gameDashboardUrl = environmentVariables.gameDashboardUrl||'https://gdbe.metaspacechain.com'
  const getReadableErrorMessage = (error) => {
  console.log("Full Error Object:", error);

  const errorString =
    error?.reason ||
    error?.shortMessage ||
    error?.data?.message ||
    error?.error?.message ||
    error?.info?.error?.message ||
    error?.message ||
    "";

  const msg = errorString.toLowerCase();

  console.log("Parsed Error Message:", msg);

  // 🔴 1. Liquidity Low
  if (
    msg.includes("not enough liquidity") ||
    msg.includes("liquidity") ||
    msg.includes("execution reverted")
  ) {
    return `Liquidity Low!
Contract liquidity is temporarily low.
Please wait a few minutes and try again.`;
  }

  // 🟡 2. Low POL (Gas)
  if (
    msg.includes("insufficient funds") ||
    msg.includes("intrinsic gas") ||
    msg.includes("gas required exceeds allowance")
  ) {
    return `Insufficient gas fee!
You do not have enough POL to complete this transaction.
Please add more POL and try again.`;
  }

  // 🟣 3. Network / RPC
  if (
    msg.includes("network error") ||
    msg.includes("failed to fetch") ||
    msg.includes("timeout") ||
    msg.includes("rpc") ||
    msg.includes("call exception")
  ) {
    return `Network Connection Issue!
Unable to connect to the Polygon network.
Please check your internet or try again shortly.`;
  }

  // ⚫ 4. User rejected
  if (
    msg.includes("user rejected") ||
    msg.includes("user denied")
  ) {
    return `Transaction failed!
Your transaction could not be completed.
Please verify your wallet login and try again.`;
  }

  // ⚫ 5. Default
  return `Transaction failed!
Your transaction could not be completed.
Please verify your wallet login and try again.`;
  };
 
  // --- Fetch Swap Limits ---
  const getSwapLimits = async () => {
    try {
      const response = await axios.get(
        `https://uat-nftbe.metaspacechain.com/nftmarketplace/api/v1/get_swap_limit`,
        {
          params: { from: getTokenName(), to: currency },
        }
      );
      if (response?.data?.success) {
        setMinLimit(response?.data?.data?.minLimit);
        setMaxLimit(response?.data?.data?.maxLimit);
        setPerDayLimit(response?.data?.data?.perDayLimit || 0);
      }
    } catch (err) {
      console.error("Failed to fetch swap limits:", err);
    }

  };
  
const handleConversion = (e) => {
  const value = e.target.value; // keep it as string
  const regex = /^\d{0,10}(\.\d{0,4})?$/;

  // allow empty input (important for backspace)
  if (value === "") {
    setCurrencyAmount("");
    setTokenAmount("");
    setDisableButton(true);
    setErrorMsg(null);
    return;
  }

  if (!regex.test(value)) return;

  const numValue = parseFloat(value);

  if (numValue < minLimit || numValue > maxLimit) {
    setCurrencyAmount(value);
    setTokenAmount(formatNumber(numValue * conversionRate));
    setDisableButton(true);
    setErrorMsg(`Amount should be between ${minLimit} to ${maxLimit}`);
  } else {
    setCurrencyAmount(value);
    setTokenAmount(formatNumber(numValue * conversionRate));
    setDisableButton(false);
    setErrorMsg(null);
  }
};

  const triggerPusher = (address) => {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/trigger_event`,
      headers: {},
      data: {address:address.toLowerCase()},
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSubmit =async () => {
  try {
    if (tokenAmount == 0 || tokenAmount == undefined || tokenAmount == null) {
      toast.error("Amount is not valid", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    if (
      currencyAmount == 0 ||
      currencyAmount == undefined ||
      currencyAmount == null
    ) {
      toast.error("Amount is not valid", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    if (!lordTokenName) {
      toast.error("Token is not selected");
      return;
    }

    setIsSubmit(true);

    let allowance = await checkAllowance(
      allContractDetails?.lordTokenContract,
      allContractDetails?.address,
      SwapingContract
    );

    allowance = ethers.formatEther(allowance);

    // 🔹 Approve if needed
    if (parseFloat(allowance) <= parseFloat(currencyAmount)) {
      await approve(
        allContractDetails?.lordTokenContract,
        SwapingContract,
        allContractDetails?.provider
      );
    }

    const tokenAmountWei = ethers.parseEther(currencyAmount.toString());

    const swapData = await swapTokens(
      allContractDetails?.swapTokenContract,
      "LORD",
      currency,
      tokenAmountWei
    );

    if (swapData?.hash) {
      setUserSwapsToday(prev => prev + 1);
      getUserBalance(allContractDetails?.address);
      setTransactionHash(swapData.hash);
      triggerPusher(allContractDetails?.address);
      setShowSucceessPopUp(true);
    } 

  } catch (error) {
    console.log("Swap Error:", error);
    const readableMessage = getReadableErrorMessage(error);

    setMessage(readableMessage);
    setIsBuyError(true);
  } finally {
    setIsSubmit(false);
  }
};

  // console.log(userBalance,'userbalanceiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii')
  const CopyAddress = async () => {
    try {
      if (transactionHash) {
        navigator.clipboard.writeText(transactionHash);
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 3000);
      } 
    } catch (error) {
      console.error("Error copying text:", error);
      toast.error("Copy failed");
    }

    setDisableButton(false);
  };
  const getTokenName = () => {
    let token;
    if (mldTokenName) {
      token = "MLD";
    } else if (maticTokenName) {
      token = "MATIC";
    } else if (lordTokenName) {
      token = "LORD";
    } else if (usdtTokenName) {
      token = "USDT";
    }
    return token;
  };
  const getConversionRates =async () => {
      let fromToken="MLD"
      if(mldTokenName)
        fromToken="MLD"
      else if(maticTokenName)
        fromToken="MATIC"
      else if(lordTokenName)
        fromToken="LORD"
      else if(usdtTokenName)
        fromToken="USDT"
      const conversionRate1 = await getRate(allContractDetails?.swapTokenContract,fromToken,"USDT");
      const conversionRate2 = await getRate(allContractDetails?.swapTokenContract,fromToken,"MLD");
      const convObj = {USDT:conversionRate1,MLD:conversionRate2}
      setConversionRates(convObj);
      setConversionRate(convObj[currency])
  };

  const explorerHandler = () => {
    let explorerUrl = "";

    if (transactionHash) {
      explorerUrl = `https://polygonscan.com/tx/${transactionHash}`;
    } 

    if (explorerUrl) {
      window.open(explorerUrl, "_blank");
    } else {
      console.error("Invalid token name or transaction hash");
    }
  };
  useEffect(() => {
    getConversionRates();
    getSwapLimits();
  }, [currency, mldTokenName, lordTokenName, usdtTokenName]);
  
  return (
    <>
    <DialogStyledUpdate
        open={isWhitelistError}
        onClose={() => setIsWhitelistError(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: { overflow: "initial", backgroundColor: "transparent" },
        }}
      >
        <ButtonCancel onClick={() => setIsWhitelistError(false)}>X</ButtonCancel>
        <div className={classes.customButton}>
          <DialogTitle
            id="alert-dialog-title"
            style={{
              textAlign: "center",
              fontSize: "32px",
              fontWeight: "600",
              color: "#fff",
              padding: "10px 0 0",
            }}
          >
            You are not whitelisted
          </DialogTitle>

          <DialogContent style={{ textAlign: "center", color: "#bbb", padding: "20px" }}>
            <DialogContentText
              id="alert-dialog-description"
              style={{ fontSize: "16px", lineHeight: "24px", color: "#bbb" }}
            >
             You’re almost there, champion! <br />
Reach <strong>Mission 4 (Arena)</strong> and collect over <strong>25,000 XP</strong> to become eligible for LORD swaps.<br />
Finish your quests and claim your rewards!
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <ButtonConfirm
              onClick={() => setIsWhitelistError(false)}
              color="primary"
              autoFocus
            >
              Got It
            </ButtonConfirm>
          </DialogActions>
        </div>
      </DialogStyledUpdate>
    {showSuccessPopUp&& (
         <DialogStyledUpdate
                open={showSuccessPopUp}
                onClose={() =>{ setShowSucceessPopUp(false);setTokenAmount(0);setCurrencyAmount(0)}}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                  sx: { overflow: "initial", backgroundColor: "transparent" },
                }}
              >
                <ButtonCancel
                  onClick={() => {
                    setShowSucceessPopUp(false);
                    setTokenAmount(0)
                    setCurrencyAmount(0)
                  }}
                  color="primary"
                >
                  X
                </ButtonCancel>
                <div className={classes.customButton}>
                  <div>
                    <ImageWrapper>
                      <Image src={SuccessIcon} />
                    </ImageWrapper>
      
                    <DialogTitle
                      id="alert-dialog-title"
                      style={{
                        textAlign: "center",
                        fontSize: "36px",
                        fontWeight: "500",
                        padding: "0",
                        color: "#fff",
                      }}
                    >
                      Transaction Successful
                    </DialogTitle>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "18px",
                          cursor: "pointer",
                          color: "#cd2222",
                          textTransform: "capitalize",
                        }}
                        onClick={explorerHandler}
                      >
                        view on explorer{" "}
                        <span>
                          <i class="fa-solid fa-arrow-up-right-dots"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <DialogContent style={{ padding: "0 0 40px" }}>
                    {/* <DialogContentText
                        id="alert-dialog-description"
                        style={{
                          textAlign: "left",
                          color: "#bbb",
                          fontSize: "16px",
                        }}
                      >
                        Please verify this information to complete the transaction
                      </DialogContentText> */}
                  </DialogContent>
                  {/* <NftNameConfirm>
                    
                      <NameandcategoriesWrapper>
                        <NftNameConfirmHead>
                        {`${
                mldTokenName !== undefined ? "MLD" : ""
              }`} {`${lordTokenName !== undefined ? "LORD" : ""}`} {`${
                maticTokenName !== undefined ? "MATIC" : ""
              }`}  Transfer 
                        </NftNameConfirmHead>
                        <NftNameConfirmSubHead>
                     
                        </NftNameConfirmSubHead>
                      </NameandcategoriesWrapper>
                      <NftNameConfirmHead>
                        {amount} {`${
                mldTokenName !== undefined ? "MLD" : ""
              }`} {`${lordTokenName !== undefined ? "LORD" : ""}`} {`${
                maticTokenName !== undefined ? "MATIC" : ""
              }`} 
                      </NftNameConfirmHead>
                    </NftNameConfirm> */}
                  {/* <NftAmountConfirm>
                      <NftAmountConfirmHead>To :</NftAmountConfirmHead>
                      <NftAmountConfirmSubHead>
                       
                        2342
                      </NftAmountConfirmSubHead>
                    </NftAmountConfirm> */}
      
                  <NftAmountConfirmHeadPur>
                    <NftAmountConfirmHead2>Transaction Hash:</NftAmountConfirmHead2>
                    <NftAmountConfirmSubHead2>
                      {`${transactionHash.slice(0,8)}...${transactionHash.slice(-8)}`}
                      <CopyIcon onClick={CopyAddress}>
                        <i class="fa-solid fa-copy"></i>
                        {isCopied && <ToolTipSpan>Copied</ToolTipSpan>}
                      </CopyIcon>
                    </NftAmountConfirmSubHead2>
                  </NftAmountConfirmHeadPur>
                  <NftAmountConfirmHeadPur>
                    <NftAmountConfirmHead2>Transaction Fee :</NftAmountConfirmHead2>
                    <NftAmountConfirmSubHead2>
                      {`0.00123 MATIC`}
                    </NftAmountConfirmSubHead2>
                  </NftAmountConfirmHeadPur>
                  <NftAmountConfirmHeadPur>
                    <NftAmountConfirmHead2>Received Amount :</NftAmountConfirmHead2>
                    <NftAmountConfirmSubHead2>
                      {`${formatNumber(tokenAmount)} ${currency=="USDT"?"USDT (POL)":currency}`}
                    </NftAmountConfirmSubHead2>
                  </NftAmountConfirmHeadPur>
                  <DialogActions>
                    <NftNameConfirm4>
                      <NftNameConfirmSubHead> Amount </NftNameConfirmSubHead>
                      <AmountHead>
                          
                      {(currencyAmount||0)} {`${mldTokenName !== undefined ? "$MLD" : ""}`}{" "}

                        {`${lordTokenName !== undefined ? "$LORD" : ""}`}{" "}
                        {`${maticTokenName !== undefined ? "MATIC" : ""}`}
                        {`${usdtTokenName !== undefined ? "USDT" : ""}`}
                      </AmountHead>
                      <AmountSubHead>{Date.now()}</AmountSubHead>
                    </NftNameConfirm4>
                  </DialogActions>
                </div>
              </DialogStyledUpdate>
    )}
     <DialogStyledUpdate
                open={isBuyError}
                onClose={() => {
                  setIsBuyError(false);
                  setIsBuyOpen(false);
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                  sx: { overflow: "initial", backgroundColor: "transparent" },
                }}
              >
                <ButtonCancel
                  onClick={() => {
                    setIsBuyError(false);
                    setIsBuyOpen(false);
                  }}
                  color="primary"
                >
                  X
                </ButtonCancel>
                <div className={classes.customButton}>
                  {/* <DialogTitle id="alert-dialog-title"  style={{textAlign:"left", fontSize:"28px", fontWeight:"500", padding:"0"}}>
              Insufficient Balance 
              </DialogTitle> */}

                  <NftNameConfirm>
                    <NftNameConfirmHead style={{whiteSpace:"pre-line"}}>{message}</NftNameConfirmHead>
                  </NftNameConfirm>

                  {/* <NftAmountConfirmHeadPur>
                <NftAmountConfirmHead2>Transaction Fee :</NftAmountConfirmHead2>
                <NftAmountConfirmSubHead2>0.015 Matic</NftAmountConfirmSubHead2>
              </NftAmountConfirmHeadPur> */}
                  {/* <DialogActions>
                <PayButtons>
                  
                  <ButtonConfirm onClick={handlePurchase} color="primary" autoFocus>
                    Confirm
                  </ButtonConfirm>
                </PayButtons>
              </DialogActions> */}
                </div>
              </DialogStyledUpdate>
    <Fortwoinputslandscape>
      <Inputwidthlandscape>
       <AddressWrapper>
         <TextWrapper>
          <Text>You Pay</Text>
        </TextWrapper>
        <div style={{ position: "relative" }}>
          <input
            style={{
              width: "100%",
              fontSize: "24px",
              background: "rgba(40,43,47,.8)",
              outline: "none",
              border: "none",
              fontWeight: "400",
              textAlign: "left",
              color: "#75787b",
              lineHeight: "16px",
              padding: "15px 15px",
              borderRadius: "10px",
              border: "none",
            }}
            value={currencyAmount}
            onKeyDown={(e)=>{
              const regex = /^[0-9]*\.?[0-9]*$/;
              if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Tab" && e.key !== "Delete" && e.key !== "ArrowLeft" && e.key !== "ArrowRight") {
                e.preventDefault();
              }
              if (e.key == "-") { 
                e.preventDefault();
              } else if (e.key == "+") {
                e.preventDefault();
              }
            }}
            onChange={handleConversion}
            placeholder="You Pay"
          />
          <div
            style={{
              position: "absolute",
              top: "15px",
              right: "15px",
              color: "#fff",
            }}
          >
            {mldTokenName && "$MLD"}
            {maticTokenName && "MATIC"}
            {lordTokenName && "$LORD"}
            {usdtTokenName && "USDT"}
          </div>
        </div>
       </AddressWrapper>
      </Inputwidthlandscape>
      {errorMsg&&errorMsg!=""?<ErrorMessage style={{color:"red"}}>{errorMsg}</ErrorMessage>:<></>}
      <Inputwidthlandscape>
        <AddressWrapper>
            <TextWrapper>
          <Text>You Receive</Text>
        </TextWrapper>
        <InputWrapper>
          <div style={{ position: "relative" }}>
            <input
              style={{
                width: "100%",
                fontSize: "24px",
                background: "rgba(40,43,47,.8)",
                outline: "none",
                border: "none",
                fontWeight: "400",
                textAlign: "left",
                color: "#75787b",
                lineHeight: "16px",
                padding: "15px 15px",
                borderRadius: "10px",
                border: "none",
                marginBottom: "20px",
              }}
              value={tokenAmount ? formatNumber(tokenAmount) : ""}
              disabled={true}
              placeholder="You Receive"
            />
             <div
            style={{
              fontSize:"16px",
              position: "absolute",
              top: "15px",
              right: "15px",
              color: "#fff",
            }}
          >
            <Styledselect
                value={currency}
                onChange={(e) => {
                  setConversionRate(conversionRates[`${e.target.value}`]);
                  setCurrency(e.target.value);
                  if (tokenAmount && currencyAmount) {
                    setTokenAmount(currencyAmount * conversionRates[`${e.target.value}`]);
                  }
                }}
              >                
                <Styledoption value="USDT">
                  USDT (POL)
                </Styledoption>
                <Styledoption value="MLD">
                  MLD
                </Styledoption>              
              </Styledselect>
          </div>
          </div>

          {/* <Paywith>Pay With</Paywith>
              <PaywithBox
                style={{
                  width: "100%",
                  fontSize: "18px",
                  background: "rgba(40,43,47,.8)",
                  outline: "none",
                  border: "none",
                  fontWeight: "400",
                  textAlign: "left",
                  color: "#75787b",
                  lineHeight: "16px",
                  padding: "15px 15px",
                  borderRadius: "10px",
                  border: "none",
                }}
                placeholder="You Receive"
              >Visa/Credit Card</PaywithBox> */}
        </InputWrapper>
        </AddressWrapper>
      </Inputwidthlandscape>
    </Fortwoinputslandscape>

  
        {mldTokenName||lordTokenName?<ConversionPrice>{`1 ${getTokenName()=="MLD"||getTokenName()=="LORD"?"$":""}${getTokenName()} = ${conversionRate && currency?(
           conversionRate
        ):0} ${currency=="USDT"?"USDT (POL)":currency}`}</ConversionPrice>:<></>}
    
      <ButtonWrapper>
        <Button
          style={
            allContractDetails && tokenAmount >= 0
              ? { cursor: "pointer" }
              : {
                  cursor: "default",
                  opacity: "0.5",
                }
          }
          disabled={tokenAmount == 0 || currencyAmount == 0||disableButton || isSwapsLoading}
        >
          <div
            style={{
              marginTop: "0px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={() => {
              if(isUserWhitelisted==false){
                setIsWhitelistError(true);
                return;
              }
              if (allContractDetails && tokenAmount >= 0) {
                if(parseFloat(userBalance?.MATIC)<0.01){
                  const error = getReadableErrorMessage({reason:"Insufficient funds for gas"})
                  setMessage(error)
                  setIsBuyError(true);
                  return;
                }
                if(mldTokenName){
                  if(parseFloat(userBalance?.MLDBalanceDec)<currencyAmount){
                    setMessage("Insufficient MLD to Swap")
                    setIsBuyError(true)
                    return
                  }
                }
                if(lordTokenName){
                  if(parseFloat(userBalance?.LORD)<currencyAmount){
                    setMessage("Insufficient LORD to Swap")
                    setIsBuyError(true)
                    return
                  }
                }
                if (userSwapsToday >= perDayLimit) {
                  setMessage("You have reached the per-day swap limit for this wallet.");
                  setIsBuyError(true);
                  return;
                }
                setConfirmPopUP(true);
              }
            }}
          >
            {isSubmit ? <CircularLoader /> : "Swap Tokens"}
          </div>
        </Button>
      </ButtonWrapper>
      <Dialog
        open={confirmPopUP}
        onClose={() => setConfirmPopUP(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: { overflow: "initial", backgroundColor: "transparent" },
        }}
      >
        <ButtonCancel onClick={() => setConfirmPopUP(false)} color="primary">
          X
        </ButtonCancel>
        <div className={classes.customButton}>
          <DialogTitle
            id="alert-dialog-title"
            style={{
              textAlign: "left",
              fontSize: "28px",
              fontWeight: "500",
              padding: "0",
            }}
          >
            Confirm Swap Token
          </DialogTitle>
          <DialogContent style={{ padding: "0 0 40px" }}>
            <DialogContentText
              id="alert-dialog-description"
              style={{
                textAlign: "left",
                color: "#bbb",
                fontSize: "16px",
              }}
            >
              Please verify this information to complete the transaction
            </DialogContentText>
          </DialogContent>

          <NftNameConfirm>
            <NftNameConfirmHead>{`${getTokenName()=="MLD"||getTokenName()=="LORD"?"$":""}${getTokenName()=="USDT"?"USDT (POL)":getTokenName()} Swapping to ${currency=="USDT"?"USDT (POL)":currency}`}</NftNameConfirmHead>
            <NftNameConfirmHead>{currencyAmount}</NftNameConfirmHead>
          </NftNameConfirm>

          <NftAmountConfirmHeadPur>
            <NftAmountConfirmHead2>Token Receive</NftAmountConfirmHead2>
            <NftAmountConfirmSubHead3>{`${currency=="USDT"?"USDT (POL)":currency} ${
              tokenAmount ? formatNumber(tokenAmount) : "0"
            }`}</NftAmountConfirmSubHead3>
          </NftAmountConfirmHeadPur>
          <DialogActions>
            <PayButtons>
              <ButtonConfirm
                onClick={(e) => {
                  setConfirmPopUP(false)
                  handleSubmit();
                  e.preventDefault();
                }}
                color="primary"
                autoFocus
              >
                Confirm
              </ButtonConfirm>
            </PayButtons>
          </DialogActions>
        </div>
      </Dialog>
    </>
  );
};

export default SwapTokensWrapper;
